import React, { useState, useEffect } from 'react';
import { CloseIcon, QuoteIcon } from './Icons';
import '../styles/QuoteModal.css';

const QuoteModal = ({ isOpen, onClose, onInsert, editingData = null }) => {
  const [content, setContent] = useState('');
  const [author, setAuthor] = useState('');
  const [about, setAbout] = useState('');
  const [error, setError] = useState('');

  // 重置表单
  const resetForm = () => {
    if (editingData) {
      // 编辑模式：预填充数据
      setContent(editingData.content || '');
      setAuthor(editingData.author || '');
      setAbout(editingData.about || '');
    } else {
      // 新建模式：清空表单
      setContent('');
      setAuthor('');
      setAbout('');
    }
    setError('');
  };

  // 当弹窗打开时重置表单
  useEffect(() => {
    if (isOpen) {
      resetForm();
    }
  }, [isOpen, editingData]);

  // 处理插入引用
  const handleInsert = () => {
    if (!content.trim()) {
      setError('请输入引用内容');
      return;
    }

    const quoteData = {
      __component: 'shared.quote',
      content: content.trim(),
      author: author || '',
      about: about || '',
      id: editingData?.id || Date.now().toString()
    };

    onInsert(quoteData);
    onClose();
  };

  // 处理键盘事件
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    } else if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      handleInsert();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="quote-modal-overlay" onClick={onClose}>
      <div className="quote-modal" onClick={e => e.stopPropagation()} onKeyDown={handleKeyDown}>
        <div className="modal-header">
          <div className="modal-title">
            <QuoteIcon size={20} />
            <h3>{editingData ? '编辑引用' : '添加引用'}</h3>
          </div>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="modal-body">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="quote-content">引用内容 *</label>
            <textarea
              id="quote-content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="输入引用的内容..."
              rows="4"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="quote-author">作者</label>
            <input
              id="quote-author"
              type="text"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
              placeholder="引用作者（可选）"
            />
          </div>

          <div className="form-group">
            <label htmlFor="quote-about">来源</label>
            <input
              id="quote-about"
              type="text"
              value={about}
              onChange={(e) => setAbout(e.target.value)}
              placeholder="作者职位、出处或其他信息（可选）"
            />
          </div>

          {/* 预览区域 */}
          {content && (
            <div className="quote-preview">
              <h4>预览效果</h4>
              <blockquote className="preview-quote">
                <p>"{content}"</p>
                {(author || about) && (
                  <footer>
                    {author && <cite>{author}</cite>}
                    {about && <span>, {about}</span>}
                  </footer>
                )}
              </blockquote>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            取消
          </button>
          <button 
            className="btn-insert" 
            onClick={handleInsert}
            disabled={!content.trim()}
          >
            {editingData ? '更新引用' : '插入引用'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuoteModal;